import { storage } from "@/utils/Storage";

import { ISessionKeys } from "@/models";

export const generateBasicAuthHeader = (username: string, password: string) => {
  if (storage.getSessionToken(ISessionKeys.BASIC_AUTH)) {
    return storage.getSessionToken(ISessionKeys.BASIC_AUTH);
  } else {
    const token = btoa(`${username}:${password}`);
    const tokenInfo = `Basic ${token}`;
    storage.setSessionToken(ISessionKeys.BASIC_AUTH, tokenInfo);
    return tokenInfo;
  }
};
